import React from 'react';
import { withStyles } from '@material-ui/core';
import Header from './components/Header';
import DataGrid from '@dataGrid';
import styles from '../../styles';
import GridConfig from './GridConfig';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import TerminalUpdateForm from './components/UpdateForm';
import MESSAGES from '../../../../../appMessages';
import StatusBar from '@dataGrid/components/StatusBar';
import DeleteDialog from './components/DeleteDialog';
import { withTerminalsHOC } from '../../common/withTerminalsHOC';
import localStyles from './styles';

class AccessibleTerminal extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.state = {
      showTerminalUpdatePanel: false,
      showDeleteTerminalDialog: false,
      quickFilterText: '',
      selectedTerminalData: null,
      selectedTerminal: null,
      terminalUpdateInProgress: false,
      terminalOptions: []
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.terminalList !== this.props.terminalList) {
      this.generateTerminalOptions();
      if (this.props.terminalDataMessage === 'error') {
        this.props.enqueueSnackbar(MESSAGES.TERMINAL_ACCESS.FETCH_DATA_FAILURE, {
          variant: 'error'
        });
      }
    }
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.gridApi.runCommand = this.runCommand;
  };

  generateTerminalOptions = () => {
    this.setState({
      terminalOptions: this.props.terminalList.map((terminal) => ({
        value: terminal.terminalId,
        label: terminal.terminalCode
      }))
    });
  };

  setSelectedTerminalData = (terminalData) => {
    this.setState({
      selectedTerminalData: terminalData,
      showDeleteTerminalDialog: true
    });
  };

  closeDeleteTerminalDialog = (refreshDataList = false) => {
    this.setState({
      selectedTerminalData: null,
      showDeleteTerminalDialog: false
    });
    if (refreshDataList) {
      this.refreshDataList();
    }
  };

  setSelectedTerminal = () => {
    if (this.state.selectedTerminal && this.gridApi) {
      this.gridApi.forEachNode((node) => {
        if (this.state.selectedTerminal === node.data.terminalCode) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true);
        }
      });
    }
  };

  runCommand = (command, data) => {
    const terminalData = { ...data };
    const commandsFunctionMap = {
      editAccessibleTerminal: this.editTerminalInfo,
      deleteAccessibleTerminal: this.setSelectedTerminalData
    };
    commandsFunctionMap[command](terminalData);
    this.setState({
      selectedTerminal: terminalData.terminalCode
    });
  };

  editTerminalInfo = (terminalData) => {
    this.setState({
      selectedTerminalData: terminalData,
      showTerminalUpdatePanel: true,
      isCreateTerminalFlow: false
    });
  };

  openAddTerminalPanel = () => {
    this.setState({
      selectedTerminalData: null,
      showTerminalUpdatePanel: true,
      isCreateTerminalFlow: true
    });
  };

  closeAddTerminalPanel = () => {
    this.setState({
      showTerminalUpdatePanel: false
    });
  };

  updateQuickFilterText = (quickFilterText) => {
    this.setState({quickFilterText});
  };

  constructStatusBar = (accessibleTerminalData) => {
    return [
      {
        label: `${accessibleTerminalData.length} Terminals`
      }
    ];
  };

  updateCreateTerminalToUpdateTerminal = () => {
    this.setState({
      isCreateTerminalFlow: false
    });
  };

  updateModel = ({
    selectedTerminal,
    terminalUpdateInProgress,
    showTerminalUpdatePanel = true,
    refreshDataList = false
  }) => {
    this.setState({
      selectedTerminal,
      terminalUpdateInProgress,
      showTerminalUpdatePanel
    });
    if (refreshDataList) {
      this.refreshDataList();
    }
  };

  refreshDataList = () => {
    if (this.props.getAllAccessibleList) {
      this.props.getAllAccessibleList();
    }
  };

  render() {
    const {
      classes,
      title,
      description,
      accessibleTerminalData,
      isDataLoaded,
      updateAPI,
      showErrorMessage
    } = this.props;
    const {
      showDeleteTerminalDialog,
      showTerminalUpdatePanel,
      selectedTerminalData,
      terminalUpdateInProgress,
      quickFilterText,
      isCreateTerminalFlow,
      selectedTerminal,
      terminalOptions
    } = this.state;
    return (
      <>
        <header className={classes.moduleHeader} data-automationid="accessibleTerminal-title">
          {title}
        </header>
        <div className={classes.moduleContainer}>
          <div className={`${classes.gridContainer} ${classes.accessibleTerminalGridContainer}`}>
            <div className={classes.moduleMessage}>{description}</div>
            <Header
              isDataLoaded={isDataLoaded}
              updateQuickFilterText={this.updateQuickFilterText}
              openAddTerminalPanel={this.openAddTerminalPanel}
              gridApi={this.gridApi}
            />
            <div
              className={`${classes.dataGrid} ${classes.terminalGrid} ${classes.feederTerminalGridHeight}`}>
              <DataGrid
                defaultColDef={this.gridConfig.config.defaultColDef}
                columnDefs={this.gridConfig.config.columns}
                config={this.gridConfig.config}
                rowSelection={this.gridConfig.config.rowSelection}
                rowData={accessibleTerminalData}
                onGridReady={this.onGridReady}
                quickFilterText={quickFilterText}
                onRowDataUpdated={this.setSelectedTerminal}
                panelLabel={(filteredData) => (
                  <StatusBar
                    data={this.constructStatusBar(filteredData)}
                    customClass={classes.statusBar}
                  />
                )}
                showErrorMessage={showErrorMessage}
                suppressRowClickSelection={showTerminalUpdatePanel}
                getRowId={(params) => params.data.terminalCode}
              />
            </div>
          </div>
        </div>
        {showTerminalUpdatePanel && (
          <TerminalUpdateForm
            terminalOptions={terminalOptions}
            selectedTerminalData={selectedTerminalData}
            open={showTerminalUpdatePanel}
            onClose={this.closeAddTerminalPanel}
            onCreateOrUpdateTerminal={this.createOrUpdateTerminal}
            terminalUpdateInProgress={terminalUpdateInProgress}
            isCreateTerminalFlow={isCreateTerminalFlow}
            drawerClasses={{
              paper: classes.paperAnchor
            }}
            variant="persistent"
            accessibleTerminalData={accessibleTerminalData}
            updateCreateTerminalToUpdateTerminal={this.updateCreateTerminalToUpdateTerminal}
            updateModel={this.updateModel}
            terminalCode={this.props.userData.userProfile.terminal.code}
            updateAPI={updateAPI}
          />
        )}
        {showDeleteTerminalDialog && (
          <DeleteDialog
            selectedTerminal={selectedTerminal}
            enqueueSnackbar={this.props.enqueueSnackbar}
            closeDeleteTerminalDialog={this.closeDeleteTerminalDialog}
            terminalCode={this.props.userData.userProfile.terminal.code}
            updateAPI={updateAPI}
          />
        )}
      </>
    );
  }
}

export default compose(
  withStyles((theme) => ({
    ...styles(theme),
    ...localStyles(theme)
  })),
  withUserProfile,
  withSnackbar
)(withTerminalsHOC(AccessibleTerminal));
